/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/

// @mui material components
import { Card } from '@mui/material'
import Grid from '@mui/material/Grid'
import Icon from '@mui/material/Icon'

// MD UI Dashboard PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

// MD UI Dashboard PRO React example components
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import DataTable from 'examples/Tables/DataTable'
import AppData from './components/data'
import MDButton from 'components/MDButton'
import ServicesModal from './components/Modals/ServicesModel'
import TeamModal from './components/Modals/TeamModal'
import { useEffect, useState } from 'react'
import { useAppServices } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import Loader from 'examples/Loader'
import FaqVideoModal from './components/Modals/FaqVideoModal'

function Default() {
	const AppService = useAppServices()
	const [agency] = useAgencyInfo()
	const { loader, teamsTable, handleRefresh, staff } = AppData()

	const onLoad = () => { }

	useEffect(onLoad, [])
	return (
		<>
			{loader ? (
				<Loader />
			) : (
				<>
					<MDBox pt={6} pb={3}>
						<Grid container spacing={6}>
							<Grid item xs={12}>
								<MDBox px={3}>
									<MDBox sx={{ textAlign: 'right' }}>
										<TeamModal
											staff={staff}
											handleRefresh={handleRefresh}
										/>
									</MDBox>
									<DataTable table={teamsTable} canSearch entriesPerPage={5} />
								</MDBox>
							</Grid>
						</Grid>
					</MDBox>
				</>
			)}
		</>
	)
}

export default Default
